import React from 'react';
import { connect } from 'react-redux';

import Render from '../../common/Render';
import * as API from '../../core/api';
import * as userDuck from '../../user/duck';

class List extends React.Component {
  removeProject = (projectId) => {
    API.post(`users/me/projects/${projectId}`, { status: 'REMOVED' }).then(
      this.props.requestUserDataIfNeeded
    );
  };

  renderItems = () => {
    const { projectsType } = this.props;
    const mofifier = projectsType === 'SIDE' ? 'c-list__item--secondary' : '';

    return this.props.userActiveProjects.map(({ project }) => (
      <li
        className={`c-list__item o-list-bare ${mofifier}`}
        key={project._id}
        value={project._id}
      >
        {project.name}
        <button
          className="c-btn c-btn--cross"
          style={{ float: 'right', marginLeft: '10px', }}
          onClick={() => this.removeProject(project._id)} />
      </li>
    ));
  };

  renderAfterLoading = () => {
    return <ul className="c-list">{this.renderItems()}</ul>;
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapStateToProps = (state, { projects, user, projectsType }) => ({
  projects:
    projects.data && projects.data.filter(({ type }) => type === projectsType),
  userActiveProjects:
    user.data &&
    user.data.projects.filter(
      ({ status, project }) =>
        status === 'ACTIVE' && project.type === projectsType
    ),
  isLoading: projects.isLoading || user.isLoading,
  error: projects.error || user.error,
});
const mapDispatchToProps = {
  requestUserDataIfNeeded: userDuck.requestDataIfNeeded,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);



// WEBPACK FOOTER //
// ./src/user/join-projects/List.js